function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assert } from "@ember/debug";
import ControlTower from "wise-control-tower";
/**
 * Medication represents two things:
 * - a medication from the "Medication database" (the "medications.js" files),
 * - a medication stored in a JE.
 *
 * This is represented by the two interfaces MedicationJSONPayload and MedicationPayload.
 * This should probably be split into two different models.
 *
 * Something to keep in mind when refactoring this part when the medication comes from the back.
 */
export default class Medication {
  constructor(payload) {
    _defineProperty(this, "cisCode", void 0);
    _defineProperty(this, "uid", void 0);
    _defineProperty(this, "dose", void 0);
    _defineProperty(this, "unit", void 0);
    _defineProperty(this, "galenic", void 0);
    _defineProperty(this, "shortDescription", void 0);
    _defineProperty(this, "longDescription", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "brand", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "molecule", void 0);
    const {
      cisCode
    } = payload;
    if (cisCode && cisCode.startsWith("CIS-")) {
      assert(`The CIS code must have 8 digits : ${cisCode}`, cisCode.length === 12);
    }
    for (const key in payload) {
      if (payload[key]) {
        this[key] = payload[key];
      }
    }

    // Have to add it there because `molecule` is a getter on the `MedicationSpecialty` model
    this.molecule = payload.molecule;
  }
  isEqual(other) {
    if (!this.cisCode && !this.name) ControlTower.captureException(new Error(`[Medication] - Failure to compare drugs due to lack of data, ${JSON.stringify(this)}`));
    return this === other || Boolean(this.cisCode && this.cisCode === other?.cisCode) || Boolean(this.name && this.name === other?.name);
  }
  get jsonPayload() {
    return {
      cisCode: this.cisCode,
      uid: this.uid,
      dose: this.dose,
      unit: this.unit,
      galenic: this.galenic,
      shortDescription: this.shortDescription,
      longDescription: this.longDescription,
      name: this.name,
      brand: this.brand,
      state: this.state,
      molecule: this.molecule
    };
  }

  /**
   * This is the name displayed on the dashboard
   */
  get displayName() {
    return this.brand || this.name;
  }
  get description() {
    return this.shortDescription || this.name || this.cisCode;
  }

  /**
   * Returns true if the Medication contains two molecules within the same ATC code.
   * For example, Medication with cisCode code 65181349 and uid Sulfamethoxazole_400_mg_+_Trimethoprime_80_mg_comprime_BACTRIM
   * has two molecules, then, two dosages and units : 400-80 and mg-mg.
   * It's the only current way to know that.
   */
  get hasSeveralMolecules() {
    return this.dose?.includes("-") && this.unit?.includes("-") || false;
  }
}